import { render } from "./pay-dialog.vue?vue&type=template&id=df5556ba&scoped=true"
import script from "./pay-dialog.vue?vue&type=script&lang=js"
export * from "./pay-dialog.vue?vue&type=script&lang=js"

import "./pay-dialog.vue?vue&type=style&index=0&id=df5556ba&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df5556ba"]])

export default __exports__